import angular from 'angular';
import uiRouter from 'angular-ui-router';
import agenciesComponent from './agencies.component';
import dataTable from 'angular-material-data-table';

let agenciesModule = angular
  .module('agencies', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('agencies', {
      url: '/agencies',
      component: 'agencies',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('agencies', agenciesComponent).name;

export default agenciesModule;
